var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gameContainer",staticStyle:{"max-width":"480px","padding":"0","max-height":"100vh !important","margin":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }